module.exports = __webpack_public_path__ + "static/the-exonerated-da9e123f78fe91b8bfd5695ad0ecfe40.jpg";